import axios from '@/axiosr8'

class NotificationsProvider {
  async postNotifications (email, assetIds) {
    let result = await axios.post('/possnotification/users/notifications/',
      {
        'email': email,
        'assetIds': assetIds
      }
    )
    return result.data
  }
}

export default new NotificationsProvider()



// WEBPACK FOOTER //
// ./src/providers/NotificationsProvider.js